module.exports = __webpack_public_path__ + "static/media/quote.f6928b1d.webp";